var map = {
	"./book/A4-P/sombra-lombada-interna.svg": 967,
	"./book/A4-R/sombra-lombada-interna.svg": 968,
	"./book/A5-P/sombra-lombada-interna.svg": 969,
	"./book/A5-R/sombra-lombada-interna.svg": 970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 966;